import Link from "next/link";
import FooterData from "../variables/variables.json";
import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import TranslatedMessage from "./TranslatedMessage";
import ActiveLink from "./ActiveLink";
import Image from "next/image";

export function Footer(props) {
  const router = useRouter();
  const intl = useIntl();

  // PROPS VARIABLE
  let propsMiasto = props.miasto;
  let propsPodatek = props.podatek;

  let propsType;
  let extendedUrl = "/";
  let siteCode = router.query.siteCode;

  if (FooterData.miasta[propsMiasto].index) {
    propsType = "/";
  } else if (FooterData.miasta[propsMiasto].witryna) {
    propsType = "/witryna/";
    extendedUrl = "?siteCode=" + siteCode;
  } else {
    propsType = "/" + FooterData.miasta[propsMiasto].name.url + "/";
  }

  const NavigationList = (props) => (
    <nav className="pd-footer__navigation" aria-label="Navigacja w stopce">
      <ul
        className={`pd-footer__navigation__list ${props.class}`}
        aria-label="functions"
        role="menu"
      >
        {props.children}
      </ul>
    </nav>
  );

  const NavigationListItem = (props) => (
    <li
      className={`pd-footer__navigation__list__item ${props.class}`}
      role="menuitem"
    >
      <a
        href={props.href}
        className="pd-footer__navigation__list__item__link"
        rel={props.rel}
      >
        {props.children}
      </a>
    </li>
  );

  // const NavigationListItem = (props) => (
  //   <li
  //     className={`pd-footer__navigation__list__item ${props.class}`}
  //     role="menuitem">
  //     <ActiveLink activeClassName="active" href={props.href}>
  //       <a className="pd-footer__navigation__list__item__link">
  //         {props.children}
  //       </a>
  //     </ActiveLink>
  //   </li>
  // )

  return (
    <>
      <footer className="pd-footer pd-section">
        <div className="pd-section__inner-wrap">
          <div className="row">
            <div className="col-xs-12 col-md hide-tablet">
              <NavigationList
                class={FooterData.footer.row.one.column.one.class}
              >
                {FooterData.footer.row.one.column.one.list.map(
                  (list, index) => (
                    <NavigationListItem
                      href={
                        list.urlOut
                          ? list.url
                          : propsType + list.url + extendedUrl
                      }
                      rel={list.rel}
                      key={index}
                    >
                      {list.image && (
                        <>
                          <div className="pd-footer__navigation__list__item__image--normal">
                            <Image unoptimized 
                              className={`pd-footer__navigation__list__item__image ${list.class}`}
                              src={list.image}
                              alt={list.title}
                              width={list.width}
                              height={list.height}
                            />
                          </div>
                          <div className="pd-footer__navigation__list__item__image--highcontrast">
                            <Image unoptimized 
                              className={`pd-footer__navigation__list__item__image ${list.class}`}
                              src={list.imageContrast}
                              alt={list.title}
                              width={list.width}
                              height={list.height}
                            />
                          </div>
                        </>
                      )}
                    </NavigationListItem>
                  )
                )}
              </NavigationList>
            </div>

            <div className="col-xs-12 col-md-7">
              <NavigationList class="row">
                {FooterData.miasta[propsMiasto].navigation.map(
                  (navigation, index) =>
                    navigation.submenu.available ? (
                      <li
                        key={index}
                        className="col-xs-12 col-md"
                        role="menuitem"
                      >
                        <span className="sr-only">
                          <TranslatedMessage
                            id={navigation.translatedMessage}
                          />
                        </span>

                        <ul role="menu">
                          {navigation.submenu.list.map((list, index) => (
                            <NavigationListItem
                              href={propsType + list.shortName + extendedUrl}
                              key={index}
                              rel={list.rel}
                            >
                              <TranslatedMessage id={list.translatedMessage} />
                            </NavigationListItem>
                          ))}
                        </ul>
                      </li>
                    ) : (
                      <NavigationListItem
                        class="col-xs-12 col-md"
                        href={propsType + navigation.shortName + extendedUrl}
                        key={index}
                      >
                        <TranslatedMessage id={navigation.translatedMessage} />
                      </NavigationListItem>
                    )
                )}
              </NavigationList>
            </div>

            <div className="col-xs-12 col-md hide-tablet">
              <NavigationList
                class={FooterData.footer.row.one.column.two.class}
              >
                {FooterData.footer.row.one.column.two.list.map(
                  (list, index) => (
                    <NavigationListItem
                      href={
                        list.urlOut
                          ? list.url
                          : propsType + list.url + extendedUrl
                      }
                      key={index}
                      rel={list.rel}
                    >
                      {list.image && (
                        <>
                          <div className="pd-footer__navigation__list__item__image--normal">
                            <Image unoptimized 
                              className={`pd-footer__navigation__list__item__image ${list.class}`}
                              src={list.image}
                              alt={list.title}
                              width={list.width}
                              height={list.height}
                            />
                          </div>
                          <div className="pd-footer__navigation__list__item__image--highcontrast">
                            <Image unoptimized 
                              className={`pd-footer__navigation__list__item__image ${list.class}`}
                              src={list.imageContrast}
                              alt={list.title}
                              width={list.width}
                              height={list.height}
                            />
                          </div>
                        </>
                      )}
                    </NavigationListItem>
                  )
                )}
              </NavigationList>
            </div>
          </div>

          <div className="row">
            {FooterData.footer.row.two.column.map((item, index) => (
              <div
                className={"col-xs-12 col-md " + (item.class ? item.class : "")}
                key={index}
              >
                <NavigationList class={item.class}>
                  {item.list.map((list, index) => (
                    <NavigationListItem
                      href={
                        list.urlOut
                          ? (list.title === "footer.processingData" &&
                              intl.formatMessage({
                                id:
                                  "miasta." +
                                  propsMiasto +
                                  ".footer.processingData",
                              })) ||
                            (list.title === "footer.regulations" &&
                              intl.formatMessage({
                                id:
                                  "miasta." +
                                  propsMiasto +
                                  ".footer.regulations",
                              })) ||
                            list.url
                          : propsType + list.url + extendedUrl
                      }
                      key={index}
                      class={list.class}
                      rel={list.rel}
                    >
                      {!list.image & (list.title === "footer.providedBy") ? (
                        <TranslatedMessage
                          id={"miasta." + propsMiasto + ".footer.providedBy"}
                        />
                      ) : (
                        !list.image && <TranslatedMessage id={list.title} />
                      )}

                      {list.image && (
                        <div className="pd-footer__navigation__list__item__image--normal">
                          <Image unoptimized 
                            className={`pd-footer__navigation__list__item__image ${list.class}`}
                            src={list.image}
                            alt={list.title}
                            width={list.width}
                            height={list.height}
                          />
                        </div>
                      )}
                    </NavigationListItem>
                  ))}
                </NavigationList>
              </div>
            ))}
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
